:host {
    opacity: 0;
    display: block;
    max-width: var(--cms-container-max-width);
    margin: 0 auto var(--cms-components-mb);
}

.accordion-group {
    @include cms-default-grid-container;
}

.accordion-group-inner {
    grid-area: var(--cms-default-grid-area);
}

@include media-width($breakpoint-sm) {
    :host([layout='two-thirds']) {
        --cms-default-grid-area: auto / 3 / auto / span 8;
    }
}